export const OPEN_GIFT_STEP: string = 'open-gift'
export const LOGIN_STEP: string = 'login'
export const REDEMPTION_SELECT_STEP: string = 'redemption-select'
export const SELECT_BRAND_STEP: string = 'select-brand'
export const ADDRESS_ENTRY_STEP: string = 'address-entry'
export const SUCCESS_STEP: string = 'success'
export const GIFT_DETAILS_STEP: string = 'gift-details'
export const ENTER_CODE_STEP: string = 'enter-code'

// eslint-disable-next-line import/no-anonymous-default-export
export default {}
